import { define } from 'wicked-elements'
import onIntersect from 'on-intersect'

function loadPreloadedImages() {
  document.querySelectorAll('img.lazyload, img.lazyloading').forEach(img => {
    if (img.complete && img.naturalWidth > 0) {
      img.classList.remove('lazyload', 'lazyloading');
      img.classList.add('lazyloaded');
    }
  });
}

// Handle bfcache/page restore globally for all ultralazy images
if (typeof window !== 'undefined') {
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      loadPreloadedImages()
    }
  });
}

// Handle Operator page restore for all ultralazy images
window.GPLA_APP.on('after', () => {
  loadPreloadedImages()
})

define('[data-component~="ultralazy"]', {
  init () {
    this.state = {}
    this.options = {...this.element.dataset}
    this.onEnter = this.onEnter.bind(this)
    this.onLoad = this.onLoad.bind(this)
  },
  connected () {
    if (!this.options.manual) {
      this.stopObserving = onIntersect(this.element, {}, this.onEnter)
    }
  },
  disconnected () {
    if (!this.options.manual) {
      this.stopObserving()
    }
  },
  onEnter (e) {
    this.loadImg()
    this.stopObserving()
  },
  loadImg () {
    this.element.classList.replace('lazyload', 'lazyloading')

    const newSrcset = this.element.dataset.srcset
    if (newSrcset) {
      if (this.element.dataset.sizes === 'auto' && this.element.offsetWidth) {
        this.element.sizes = `${this.element.offsetWidth}px`
      }
      this.element.srcset = newSrcset
    }

    const newSrc = this.element.dataset.src
    if (newSrc) this.element.src = newSrc
  },
  onLoad () {
    if (this.element.classList.contains('lazyloading')) {
      this.element.classList.replace('lazyloading', 'lazyloaded')
    }
  },
  onTriggerLoad () {
    const classList = this.element.classList
    if (!classList.contains('lazyloading') && !classList.contains('lazyloaded')) {
      this.loadImg()
    }
  }
})